<template>

    <form autocomplete="off" class="pl-3" v-on:submit.prevent="close" v-show="loaded">
  
        <h5 class="font-weight-bold">{{ lang.polaris.dashboard.level }}</h5>
        <trax-ui-choice  v-model="form.level" :error="errors.level" :options="level_select" allow-unselect="1">
        </trax-ui-choice>

        <div v-for="category in categories" :key="category.id">
            <h5 class="font-weight-bold mt-4">{{ category.name }}</h5>
            <div class="clearfix" v-for="item in category.children" :key="item.id" v-if="!item.title">

                <trax-ui-choice v-model="form.indicators[item.uuid]" :options="indicator_select"
                    size="xs" plain-icons="1" class="float-left" allow-unselect="1">
                </trax-ui-choice>
                <p style="padding-left:75px; white-space:pre-wrap;">{{ item.name }}</p>

            </div>
        </div>

        <h5 class="font-weight-bold mt-5">{{ lang.polaris.dashboard.comments }}</h5>
        <trax-ui-input v-model="form.comments" :error="errors.comments" rows="5">
        </trax-ui-input>

        <div class="trax-form-actions text-center">
            <button type="submit" class="btn btn-default btn-round" :disabled="mustSelectLevel && !levelSelected"> {{ lang.polaris.form.close }} </button>
            <div class="text-danger font-weight-bold" v-if="mustSelectLevel && !levelSelected">
                {{ lang.polaris.dashboard.level_must_select }}
            </div>
        </div>
    </form>
    
</template>

<script>
    export default {

        props: {
            id: {default: 'enac-atpl-dashboard-flight-follow-up-learner-edit-competencies-select'},
            bus: null
        },
    
        data: function() {
            return {
                lang: lang,
                endpoint: app_url+'polaris/api/front/competency-items',
                loaded: false,
                competency_indexes: {
                    'general-criteria': data.program.gc_index_id,
                    'behavioural-indicator': data.program.bi_index_id,
                },
                form: {
                    level: '',
                    comments: '',
                    indicators: {}
                },
                level_select: [
                    {value: 1, name: lang.polaris.dashboard.unsatisfactory, color: 'danger'},
                    {value: 2, name: lang.polaris.dashboard.partially_satisfactory, color: 'warning'},
                    {value: 3, name: lang.polaris.dashboard.satisfactory, color: 'success'},
                ],
                indicator_select: [
                    {value: 1, icon: 'error_outline', color: 'danger'},
                    {value: 3, icon: 'check', color: 'success'},
                ],
                errors: {},
                typeCode: null,
                categories: {}
            }
        },

        computed: {

            competencyIndexId() {
                return this.competency_indexes['general-criteria'];
            },

            mustSelectLevel() {
                for (var key of Object.keys(this.form.indicators)) {
                    if (this.form.indicators[key]) {
                        return true
                    }
                }
                return this.form.comments != null && this.form.comments.trim().length > 0
            },

            levelSelected() {
                return this.form.level > 0
            }
        },

        created: function() {
            this.bus.$on(this.id+'-open', this.initData);
        },

        watch: {
            
            form: function() {
                if (this.loaded) this.setState();
            }
        },

        methods: {

            initData(titleAndData) {
                this.loaded = false,
                this.errors = {};
                this.typeCode = titleAndData.data.type_code;
                this.form = titleAndData.data.states;
                this.loadData();
            },
            
            loadData() {
                var that = this;
                axios.get(this.endpoint, {
                    params: {
                        filters: {
                            type: that.typeCode,
                            index_id: that.competencyIndexId,
                            parent_id: { $exists: false }
                        },
                        relations: ['children'],
                        sort: ['order']
                    }})
                    .then(function (response) {
                        that.categories = response.data.data;
                        that.loaded = true;
                        that.setState();
                    })
                    .catch(function (error) {
                    });
            },
            
            setState() {
                this.bus.$emit(this.id+'-set', {type_code: this.typeCode, states: this.form, indicators: this.indicatorNames()});
            },

            close() {
                this.bus.$emit(this.id+'-close');
            },

            indicatorNames() {
                var indicators = {};
                for (var index1 in this.categories) {
                    for (var index2 in this.categories[index1].children) {
                        var item = this.categories[index1].children[index2];
                        indicators[item.uuid] = item.name;
                    }
                }
                return indicators;
            }
        }

    }
</script>
